import { render, staticRenderFns } from "./EditDialog.vue?vue&type=template&id=2c1e03b3"
import script from "./EditDialog.vue?vue&type=script&lang=js"
export * from "./EditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports